import React, { Component } from 'react';

class Units extends Component {
	render() {
		const { title, description, units } = this.props.data;
		return (
			<section id="units">
				<div className="container container-fluid">
					<div className="row between-md">
						<div className="col-md-3 col-xs-12">
							<h3>{title}</h3>
						</div>
						<div className="col-md-8 col-xs-12">
							<p>{description}</p>
						</div>
					</div>
					<div className="units row around-xs">
						{units.map((unit, index) => (
							<div key={index} className="unit col-md-6 col-xs-12 center-xs">
								<div className="image center-xs">
									<img
										src={
											process.env.REACT_APP_API_ENDPOINT + unit.value.image.path
										}
										alt={unit.value.title}
									/>
								</div>
								<h4>{unit.value.title}</h4>
								<p>{unit.value.description}</p>
							</div>
						))}
					</div>
				</div>
			</section>
		);
	}
}

export default Units;
